import { Component, ChangeDetectionStrategy, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogRef, MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { ButtonComponent, TooltipDirective } from '@mode/capra';
import { AnalyticsEvent, AnalyticsService, RunMethodType } from '@mode/shared/util-segment';
import { CalendlyPopupButtonComponent } from '../calendly-popup-button/calendly-popup-button.component';
import { DialogHeaderComponent } from '../dialog/header/dialog-header.component';

@Component({
  standalone: true,
  selector: 'mode-trial-ended-dialog',
  imports: [
    ButtonComponent,
    CalendlyPopupButtonComponent,
    DialogHeaderComponent,
    MatLegacyDialogModule,
    TooltipDirective,
  ],
  templateUrl: './trial-ended-dialog.component.html',
  styleUrls: ['./trial-ended-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrialEndedDialogComponent implements OnInit {
  hideClose = false;

  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA)
    public data: { userDisplayName: string; userEmail: string },
    public dialogRef: MatLegacyDialogRef<TrialEndedDialogComponent>,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit(): void {
    // for this component, disabling default close actions should also hide the close button
    // grab the property from the dialogRef and pass it to the header
    this.hideClose = !!this.dialogRef.disableClose;
  }

  // send 'UI Clicked' event to segment
  trackClick(location: string, action: string): void {
    this.analyticsService.run(RunMethodType.Track, AnalyticsEvent.Name.UiClicked, {
      location: location,
      action: action,
      email: this.data.userEmail,
    });
  }
}
